import React from 'react';
import logoarbor from './../assets/arbor.png';
import logoF2 from './../assets/f2.png';
import './index.css'; 

function Footer(){
  var ano = new Date().getFullYear(); 
    return <footer className="footer-section">
                  <div className="footer-cor mt-12 ">                  
                        <div className="container-fluid ms footer-social"> 
                          <ul className="list-unstyled list-inline social text-center">
                            <div className="text-secondary footer-font">Licença: Floresta Comércio e Indústria SA</div>
                            <li className="list-inline-item "><a href="https://fb.com/florestasm"><i className="bi bi-facebook fa-2x cor-icon"></i></a></li>
                            <li className="list-inline-item"><a href="https://x.com/florestavr">  <i className="bi bi-twitter-x fa-2x cor-icon"></i></a></li>
                            <li className="list-inline-item"><a href="http://www.instagram.com.br/florestasm"><i className="bi bi-instagram fa-2x cor-icon"  ></i></a></li>						
                            <li className="list-inline-item"><a href="mailto:suporte@florestasm.com.br" target="_blank"><i className="bi bi-envelope fa-2x cor-icon"></i></a></li>
                            <li className="list-inline-item"><a href="https://t.me/florestasm" target="_blank"><i className="bi bi-telegram fa-2x cor-icon"></i></a></li>
                            <li className="list-inline-item"><a href="https://wa.me/5524988213451" target="_blank"><i className="bi bi-whatsapp fa-2x cor-icon"></i></a></li>
                            <li className="list-inline-item"><a href="https://br.linkedin.com/company/floresta-supermarket" target="_blank"><i className="bi bi-linkedin fa-2x cor-icon" aria-hidden="true"></i></a></li>
                            
                            <div className="text-secondary footer-font">{ano} - Desenvolvido por</div>
                            <img className="footer-logos logo-blink" alt="" height="70" src={logoF2}></img>
                            </ul>                        
                        </div>                        
                  </div>                  
              </footer>
  }

export default Footer;